

export default function ControlButtons({onCancel, onSave, className,cancelDisabled,saveDisabled}){  
    return(
        <div className={"buttons " + className}>
            <button disabled={cancelDisabled} className='cancel-button' onClick={onCancel}>Cancelar</button>
            <button disabled={saveDisabled} className='save-button' onClick={onSave}>Guardar</button>
        </div>
    )
}